// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import { Helmet } from "react-helmet";
import useFavicon from "../utils/useFavicon";

export default function SEO({
  title,
  description,
  image = "https://www.harivishnu.in/images/home_images/Logo.png",
  url,
  type = "website",
  author = "Hari Vishnu",
  publishedTime,
  modifiedTime,
  keywords,
  // New SEO fields from Hygraph
  seoTitle,
  seoDescription,
  seoKeywords,
  seoImage,
  noIndex = false,
  favicon,
}) {
  // Use SEO fields from Hygraph with fallbacks
  const finalTitle = seoTitle || title;
  const finalDescription = seoDescription || description;
  const finalKeywords = seoKeywords || keywords;

  // Handle image fallback: use seoImage, or image, or fall back to default logo if both are empty/falsy
  // Note: Default prop value only applies if prop is undefined, not if it's an empty string.
  const defaultBlogThumbnail = process.env.REACT_APP_BLOG_DEFAULT_THUMBNAIL || "https://blog-post-details.s3.eu-north-1.amazonaws.com/Blog+Default+Thumbnail.jpg";
  const defaultLogo = "https://www.harivishnu.in/images/home_images/Logo.png";
  
  const defaultImage = type === "article" ? defaultBlogThumbnail : defaultLogo;
  const finalImage =
    seoImage || (image && image.trim() !== "" ? image : defaultImage);

  const fullTitle = finalTitle
    ? `${finalTitle} | Hari Vishnu`
    : "Hari Vishnu | Personal Blog, Projects & Portfolio";
  const fullDescription =
    finalDescription ||
    "Welcome to Hari Vishnu's official website. Explore insightful blog posts, personal projects, portfolio highlights, and more.";
  const fullUrl = url || "https://www.harivishnu.in";
  const fullImage = finalImage.startsWith("http")
    ? finalImage
    : `https://www.harivishnu.in${finalImage}`;

  useFavicon(favicon);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="author" content={author} />
      {finalKeywords && <meta name="keywords" content={finalKeywords} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Hari Vishnu" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:creator" content="@Im_Harivishnu" />

      {/* Additional meta tags */}
      <meta
        name="robots"
        content={noIndex ? "noindex,nofollow" : "index,follow"}
      />
      <meta name="language" content="en-IN" />
      <meta name="geo.region" content="IN" />
      <meta name="geo.placename" content="India" />
      <meta name="geo.position" content="20.5937;78.9629" />
      <meta name="ICBM" content="20.5937,78.9629" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* Article specific meta tags */}
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      {author && <meta property="article:author" content={author} />}

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
}

